import { useMemo } from 'react';
import { Subcontractor } from '@models/organization.model';
import { ProjectOption } from '../types';

interface UseProjectOptionsProps {
  subcontractors: Subcontractor[];
  selectedOrganizationId?: string | null;
}

export const useProjectOptions = ({
  subcontractors,
  selectedOrganizationId,
}: UseProjectOptionsProps) => {
  return useMemo(() => {
    const allProjects: ProjectOption[] = [];

    // Filter subcontractors based on selected organization
    const filteredSubcontractors = selectedOrganizationId
      ? subcontractors.filter(
          (sub) => sub.organizationId === selectedOrganizationId,
        )
      : subcontractors;

    // Build project options
    filteredSubcontractors.forEach((sub) => {
      if (sub.projects?.length > 0) {
        sub.projects.forEach((project) => {
          allProjects.push({
            label: selectedOrganizationId
              ? project.name // Just project name if organization is selected
              : `${project.name} (${sub.name})`, // Include company name if no organization selected
            value: project.projectId,
            organizationId: sub.organizationId,
          });
        });
      }
    });

    return allProjects;
  }, [subcontractors, selectedOrganizationId]);
};